import { usePageContext } from '~components/PageDataProvider/PageDataProvider';

import arrow from './images/forward.svg';
import email from './images/ic-email.svg';
import facebook from './images/ic-facebook.svg';
import pinterest from './images/ic-pinterest.svg';
import twitter from './images/ic-twitter.svg';

type Props = {
    body?: string;
    subject?: string;
};

const Share = ({ body = '', subject = '' }: Props) => {
    const pageData = usePageContext();
    const pageUrl = pageData?.location?.href;

    const openEmail = (e: React.MouseEvent) => {
        e.preventDefault();
        if (window.navigator.share) {
            void window.navigator.share({
                text: body,
                title: subject,
                url: pageUrl,
            });
        } else {
            window.location.href = `mailto:?subject=${subject}&body=${body + ' ' + pageUrl}`;
        }
    };

    const PLATFORMS = [
        {
            name: 'Facebook',
            url: 'http://www.facebook.com/sharer.php?u=' + pageUrl,
            logo: facebook,
        },
        {
            name: 'Twitter',
            url: 'https://twitter.com/intent/tweet?url=' + pageUrl + '&text=' + subject,
            logo: twitter,
        },
        {
            name: 'Pinterest',
            url: 'http://pinterest.com/pin/create/button/?url=' + pageUrl,
            logo: pinterest,
        },
    ];

    return (
        <div className="flex items-center justify-center h-8 text-base print:hidden">
            <span className="flex">
                <img src={arrow} alt="" aria-hidden className="mr-1" />
                Share:
            </span>
            <ul className="flex justify-between">
                {PLATFORMS.map((link) => {
                    return (
                        <li key={link.name}>
                            <a
                                href={link.url}
                                target="_blank"
                                rel="noreferrer"
                                data-wa-link={`Share:${link.name}`}
                                data-qa={`share-${link.name}`}
                                aria-label={`Share this article to ${link.name}`}
                            >
                                <img src={link.logo} alt={`share to ${link.name}`} />
                            </a>
                        </li>
                    );
                })}
                <li key="email">
                    <button
                        onClick={openEmail}
                        data-qa="share-Email"
                        data-wa-link="Share:Email"
                        aria-label="Share this article by email"
                    >
                        <img src={email} alt="share to email" />
                    </button>
                </li>
            </ul>
        </div>
    );
};

export default Share;
